import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  MenuItem,
  Button,
  TextField,
  IconButton,
  CircularProgress,
  Backdrop,
  Paper,
  Modal,
  Fade,
  Snackbar,
  Alert,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { display } from "../../redux/reducers/sidebar";
import { AddBox } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import dayjs from "dayjs";
import {
  createLUTBondMaster,
  deleteLUTBondMaster,
  updateLUTBondMaster,
} from "../../graphql/mutations";
import { listLUTBondMaster } from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import moment from "moment";

const LUTTableHeaders = [
  {
    id: "S. No",
    label: "Sl. No",
    width: "50px",
  },
  {
    id: "LutNo",
    label: "LUT / Bond No",
    width: "150px",
  },
  {
    id: "validFrom",
    label: "Valid From",
    width: "150px",
  },
  {
    id: "validTo",
    label: "Valid To",
    width: "150px",
  },
  {
    id: "expires",
    label: "Expires      (in days)",
    width: "80px",
  },
  {
    id: "action",
    label: "Action",
    width: "100px",
    align: "right",
  },
];

const countPerPage = [
  {
    value: "5",
    label: "5",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "15",
    label: "15",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  paddingBottom: 2,
  outline: "none",
};
function LutViewNewModal({
  open,
  setOpen,
  currentYear,
  //   setLutRows,
  //   lutRows,
  //   lutState,
  setLutState,
  lutState,
}) {
  const [listLUT, setListLUT] = useState([]);
  const [err, setErr] = useState(false);
  const [dateFrom, setDateFrom] = useState(false);
  const [editedRow, setEditedRow] = useState({
    id: 0,
    lut: "",
    validFrom: "",
    validTo: "",
    editable: false,
    expiry: "",
    new: false,
  });
  const textref = useRef(null);
  const [editData, setEditData] = useState({});
  const textFieldRefs = useRef([]);
  const [editClick, setEditClick] = useState(false);
  const [checkList, setCheckList] = useState("");
  const [backdropOpen, setBackdropOpen] = useState(false);
  const buttonRefclose = useRef();
  const editBtnref = useRef();
  const modalClose = useRef();
  const validFromref = useRef();
  // let diffInDaysNew;
  const handleValidFromNew = (newValue, con) => {
    setEditedRow({
      ...editedRow,
      expiry: "",
    });
    if (con.validationError === "invalidDate") {
      showWarningSnackbar(con.validationError);
    }
    const vFrom = new Date(dayjs(newValue));
    const currentDate = moment().format("YYYY-MM-DD");
    const date = new Date(newValue);
    const finEndDate = moment(date).clone().add(1, "year").month(2).date(31);
    const finEndDatex = moment(finEndDate).format("YYYY-MM-DD");
    const diffInDaysNew = moment(finEndDatex).diff(moment(currentDate), "days");
    setEditedRow({
      ...editedRow,
      validFrom: moment(vFrom).format("YYYY-MM-DD"),
      validTo: finEndDatex,
      expiry: diffInDaysNew,
    });
  };

  const [snakopen, setsnakOpen] = React.useState(false);

  const handleSnakClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setsnakOpen(false);
  };

  const handleValidToNew = (newValue, con) => {
    if (con.validationError === "invalidDate") {
      showWarningSnackbar(con.validationError);
    }
    const vTo = moment(new Date(dayjs(newValue))).format("YYYY-MM-DD");
    const currentDate = moment().format("YYYY-MM-DD");
    const diffInDaysNew = moment(vTo).diff(moment(currentDate), "days");
    setEditedRow({
      ...editedRow,
      validTo: vTo,
      expiry: diffInDaysNew,
    });
  };

  const handleEditChangeValidTo = (newValue, con, column) => {
    if (con.validationError === "invalidDate") {
      showWarningSnackbar(con.validationError);
    }
    const vTo = moment(new Date(dayjs(newValue))).format("YYYY-MM-DD");
    const currentDate = moment().format("YYYY-MM-DD");
    const diffInDaysNew = moment(vTo).diff(moment(currentDate), "days");
    setListLUT(
      listLUT.map((lut) =>
        lut?.ID === column?.ID
          ? {
              ...lut,
              // ValidFrom: Math.floor(new Date(date).getTime() / 1000),
              ValidTo: Math.floor(new Date(vTo).getTime() / 1000),
              // expiry: diffInDaysNew,
            }
          : lut
      )
    );
  };
  useEffect(() => {
    if (editClick && textFieldRefs.current) {
      textFieldRefs?.current?.focus();
      setEditClick(false);
    }
  }, [editClick]);

  const updateLUT = async (column) => {
    // const validfro = dayjs(
    //   new Date(column.ValidFrom * 1000).toLocaleDateString()
    // ).get("year");
    const removeCurrentYear = dayjs(
      new Date(editData.ValidFrom * 1000).toLocaleDateString()
    ).get("year");
    const removeCurrentYearTo = dayjs(
      new Date(editData.ValidTo * 1000).toLocaleDateString()
    ).get("year");
    const checkjj = [...checkList].map((f) =>
      dayjs(new Date(f?.ValidFrom * 1000).toLocaleDateString()).get("year")
    );
    const gg = checkjj.filter((item) => item !== removeCurrentYear);
    const currentDate = moment().format("YYYY-MM-DD");

    const validTo = new Date(column?.ValidTo * 1000).toLocaleDateString();

    const finEndDate = moment(validTo).format("YYYY-MM-DD");
    const diffInDays = moment(finEndDate).diff(moment(currentDate), "days");
    if (currentYear == removeCurrentYear) {
      setLutState((prev) => ({
        ...prev,
        ["formtwo"]: {
          ...prev["formtwo"],
          lutBondNo: column?.LUTNo,
          lutValidFrom: new Date(column?.ValidFrom * 1000).toLocaleDateString(),
          lutValidTo: new Date(column?.ValidTo * 1000).toLocaleDateString(),
          lutExpiry: diffInDays,
        },
      }));
    }
    const checkvv = [...checkList].map((f) =>
      dayjs(new Date(f?.ValidTo * 1000).toLocaleDateString()).get("year")
    );
    const gga = checkvv.filter((item) => item !== removeCurrentYearTo);

    if (
      !gg.includes(checkjj) &&
      !gga.includes(
        dayjs(new Date(column.ValidTo * 1000).toLocaleDateString()).get("year")
      )
    ) {
      setBackdropOpen(true);
      try {
        const res = await API.graphql(
          graphqlOperation(updateLUTBondMaster, {
            updateLUTBondMasterInput: {
              LUTNo: column.LUTNo.trim(),
              ID: column.ID,
              ValidFrom: column.ValidFrom,
              ValidTo: column.ValidTo,
            },
          })
        );
        showSuccessSnackbar("LUT updated");
        setEditData({
          ...editData,
          editable: false,
        });
      } catch (error) {
        console.log("error", error);
      }
      setListLUT(
        listLUT.map((lut) =>
          lut.ID === column.ID ? { ...lut, editable: false } : lut
        )
      );
      setBackdropOpen(false);
    } else {
      showWarningSnackbar("This year already exists");
    }
  };

  const handleEditBtnClick = async (e, column) => {
    // if (
    //   validFromref.current &&
    //   validFromref.current.contains(e?.relatedTarget)
    // ) {
    //   return; // Prevent blur action
    // }

    console.log(validFromref, "validFromref");
    // setListLUT([...checkList]);

    if (column.LUTNo === "") {
      setsnakOpen(true);
    }
    setEditData(column);
    if (!column.ValidFrom) {
      showWarningSnackbar("Please provide valid Date");
    }
    setEditedRow({
      ...editedRow,
      editable: false,
    });
    if (!column.editable) {
      setEditClick(true);
      setListLUT(
        listLUT.map((lut) => {
          if (lut.ID === column.ID) {
            return {
              ...lut,
              editable: true,
            };
          } else {
            return {
              ...lut,
              editable: false,
            };
          }
          //  else if (lut.editable === true) {
          //   const newValue = checkList.find((newRow) => newRow.ID === lut.ID);

          //   if (newValue) {
          //     return { ...newValue, editable: false };
          //   }
          // }
        })
      );
    }
    // if (column.LUTNo.trim() === "") {
    //   showWarningSnackbar("Please provide LUT Number");
    // }
    console.log(editData, "editData");
    console.log(column, "column");
    console.log(listLUT, "listLUT");
    if (
      column.editable === true &&
      column.LUTNo.trim() !== "" &&
      (column.LUTNo !== editData.LUTNo ||
        column.ValidFrom !== editData.ValidFrom ||
        column.ValidTo !== editData.ValidTo)
    ) {
      updateLUT(column);
    }
    // else if (
    //   column.editable === true &&
    //   column.LUTNo.trim() !== "" &&
    //   column.LUTNo !== "" &&
    //   column.ValidFrom !== "" &&
    //   column.ValidTo !== ""
    // ) {
    //   console.log(dateFrom, "datefrom");
    //   setListLUT(
    //     listLUT.map((lut) =>
    //       lut.ID === column.ID &&
    //       column.LUTNo !== "" &&
    //       column.ValidFrom !== "" &&
    //       column.ValidTo !== ""
    //         ? { ...lut, editable: false }
    //         : lut
    //     )
    //   );
    //   setEditData({
    //     ...editData,
    //     editable: false,
    //   });
    // }
    setsnakOpen(false);
  };
  console.log(listLUT, "listLUT");
  useEffect(() => {
    if (textref.current) {
      textref.current.value = "";
      textref.current.focus();
    }
  }, [editedRow.id]);
  useEffect(() => {
    if (editedRow.editable && textref.current) {
      if (textref.current) {
        textref.current.value = "";
        textref.current.focus();
      }
    }
  }, [editedRow.editable]);

  function addNewRow(e) {
    e.preventDefault();
    setListLUT(
      listLUT.map((lut) => (lut?.ID ? { ...lut, editable: false } : lut))
    );
    textref?.current?.focus();
    setEditedRow({
      id: listLUT.length + 1,
      lut: "",
      validFrom: "",
      validTo: "",
      editable: true,
      new: true,
    });
    // }
  }

  async function addLUTDetails(data) {
    console.log(data, "data");
    console.log(currentYear, "currentYear");
    const removeCurrentYear = dayjs(
      new Date(data.ValidFrom * 1000).toLocaleDateString()
    ).get("year");
    console.log(removeCurrentYear, "removeCurrentYear");
    setBackdropOpen(true);
    try {
      const res = await API.graphql(
        graphqlOperation(createLUTBondMaster, {
          createLUTBondMasterInput: data,
        })
      );
      showSuccessSnackbar("LUT added");
      if (currentYear == removeCurrentYear) {
        setLutState((prev) => ({
          ...prev,
          ["formtwo"]: {
            ...prev["formtwo"],
            lutBondNo: data.LUTNo,
            lutValidFrom: dayjs(new Date(data.ValidFrom * 1000)),
            lutValidTo: dayjs(new Date(data.ValidTo * 1000)),
          },
        }));
      }
      listLUTFn();
      setBackdropOpen(false);
    } catch (error) {
      console.log(error);
    }
  }
  console.log(lutState, "lut state");
  const listLUTFn = async () => {
    setBackdropOpen(true);
    try {
      const res = await API.graphql(graphqlOperation(listLUTBondMaster));
      setListLUT(res?.data?.listLUTBondMaster);
      setCheckList(res?.data?.listLUTBondMaster);
    } catch (err) {
      console.log(err, "err");
    }
    setBackdropOpen(false);
  };
  const checkjj = [...checkList].map((f) =>
    dayjs(new Date(f?.ValidFrom * 1000).toLocaleDateString()).get("year")
  );
  const createLut = () => {
    if (editedRow.validFrom === "" || editedRow.validTo === "") {
      showWarningSnackbar("Please provide Valid dates");
    } else if (
      editedRow.lut &&
      editedRow.validFrom !== "Invalid date" &&
      editedRow.validTo !== "Invalid date"
    ) {
      const checkjj = [...checkList].map((f) =>
        dayjs(new Date(f?.ValidFrom * 1000).toLocaleDateString()).get("year")
      );
      const checkvv = [...checkList].map((f) =>
        dayjs(new Date(f?.ValidTo * 1000).toLocaleDateString()).get("year")
      );
      if (
        !checkjj.includes(dayjs(editedRow.validFrom).get("year")) &&
        !checkvv.includes(dayjs(editedRow.validTo).get("year"))
      ) {
        const lutDetails = {
          LUTNo: editedRow.lut,
          ValidFrom: Math.floor(new Date(editedRow.validFrom).getTime() / 1000),
          ValidTo: Math.floor(new Date(editedRow.validTo).getTime() / 1000),
        };
        addLUTDetails(lutDetails);
        setEditedRow({
          lut: "",
          validFrom: null,
          validTo: "",
          editable: false,
        });
      } else {
        showWarningSnackbar("This year already exists");
      }
      // const listcheck = checkList.filter(f => f.)
    } else {
      showWarningSnackbar("Please provide all values");
    }
  };
  const handleEditEnterClick = async (event, column) => {
    // if (event.key === "Enter") {
    //   console.log(column, "column");
    //   showWarningSnackbar("Please provide valid Date");
    // }
    if (event.key === "Enter") {
      handleEditBtnClick(event, column);
      // updateLUT(column);
    }
  };

  const handleNewEnterKey = (event) => {
    if (
      event.key === "Enter" &&
      editedRow.lut &&
      editedRow.validFrom &&
      editedRow.validTo
    ) {
      createLut();
    } else if (event.key === "Enter") {
      showWarningSnackbar("Please provide Valid LUT details");
    }
  };

  const handleEditChange = (e, column) => {
    if (column.LUTNo !== "" || e.target.value !== "") {
      setErr(false);
    } else {
      setErr(true);
      // showWarningSnackbar("Please provide LUT Number");
      setsnakOpen(true);
    }
    setListLUT(
      listLUT.map((lut) =>
        lut?.ID === column?.ID ? { ...lut, LUTNo: e.target.value } : lut
      )
    );
    setsnakOpen(false);
  };
  const handleEditChangeValid = (date, context, column) => {
    if (context.validationError === "invalidDate") {
      showWarningSnackbar(context.validationError);
    }

    const currentDate = moment().format("YYYY-MM-DD");
    const datech = new Date(date);
    const finEndDate = moment(datech).clone().add(1, "year").month(2).date(31);
    const finEndDatex = moment(finEndDate).format("YYYY-MM-DD");
    const diffInDaysNew = moment(finEndDatex).diff(moment(currentDate), "days");
    // setEditedRow({
    //   ...editedRow,
    //   validFrom: newValue,
    //   validTo: finEndDatex,
    //   expiry: diffInDaysNew,
    // });
    setListLUT(
      listLUT.map((lut) =>
        lut?.ID === column?.ID
          ? {
              ...lut,
              ValidFrom: Math.floor(new Date(date).getTime() / 1000),
              ValidTo: Math.floor(new Date(finEndDatex).getTime() / 1000),
              expiry: diffInDaysNew,
            }
          : lut
      )
    );
  };
  const handleDelete = async (col) => {
    setBackdropOpen(true);
    try {
      const res = await API.graphql(
        graphqlOperation(deleteLUTBondMaster, { ID: col.ID })
      );
    } catch (err) {
      console.log(err, "err");
    }
    setBackdropOpen(false);
    showSuccessSnackbar("LUT Deleted");
    const removeCurrentYear = dayjs(
      new Date(col.ValidFrom * 1000).toLocaleDateString()
    ).get("year");
    if (currentYear == removeCurrentYear) {
      setLutState((prev) => ({
        ...prev,
        ["formtwo"]: {
          ...prev["formtwo"],
          lutBondNo: "",
          lutValidFrom: "",
          lutValidTo: "",
        },
      }));
    }
    listLUTFn();
  };
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setsnakOpen(false);
    }
  };

  const handleLUT = (val) => {
    if (val === "") {
      showWarningSnackbar("Please provide LUT Number");
      setEditedRow({
        ...editedRow,
        lut: "",
      });
    } else {
      setEditedRow({
        ...editedRow,
        lut: val,
      });
    }
  };
  const handleBlur = (event) => {
    // event.stopPropagation();
    // console.log(event.target.value, "blur val");

    if (
      buttonRefclose.current &&
      buttonRefclose.current.contains(event?.relatedTarget)
    ) {
      return; // Prevent blur action
    }
    if (
      modalClose.current &&
      modalClose.current.contains(event?.relatedTarget)
    ) {
      return; // Prevent blur action
    }
    if (
      editBtnref.current &&
      editBtnref.current.contains(event?.relatedTarget)
    ) {
      return; // Prevent blur action
    }
    if (event.target.value == "") {
      setsnakOpen(true);
    } else if (editedRow.validFrom && editedRow.validTo && editedRow.lut) {
      createLut();
    }
  };
  useEffect(() => {
    listLUTFn();
  }, []);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
              position: "sticky",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "600",
                  alignItems: "center",
                }}
              >
                <Typography>Add New LUT Details</Typography>
                <IconButton
                  aria-label="delete"
                  ref={modalClose}
                  onClick={handleClose}
                >
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box sx={{ padding: { xs: "10px 10px", sm: "10px 10px" } }}>
            <TableContainer
              sx={{
                height: "500px",
                overflow: "auto",
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#057d8647",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#057d8647",
                },
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {LUTTableHeaders.map((column) => {
                      return (
                        <TableCell
                          sx={{ minWidth: column.width }}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {editedRow.editable && (
                    <TableRow hover role="checkbox" id="yourTableRowId">
                      <TableCell sx={{ width: "50px" }}></TableCell>
                      <TableCell sx={{ width: "150px" }}>
                        <TextField
                          size="small"
                          inputRef={textref}
                          required={true}
                          type="text"
                          error={editedRow.lut ? false : true}
                          value={editedRow.lut}
                          onChange={(e) => handleLUT(e.target.value)}
                          onBlur={handleBlur}
                          onKeyDown={(e) => handleNewEnterKey(e)}
                        />
                      </TableCell>
                      <TableCell sx={{ width: "150px" }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            // error={state?.errorStatus[name] === true}
                            label="Valid From"
                            format="DD/MM/YYYY"
                            size="small"
                            // value={value || null}
                            // minDate={minDate !== null ? minDate : null}

                            sx={{
                              "& .MuiFormLabel-root": {
                                top: `${
                                  editedRow.validFrom === "" ? "-9px" : "0px"
                                }`,
                              },
                              ".MuiInputBase-input": {
                                padding: "8.5px 14px",
                              },
                              // '& .MuiInputBase-input': {
                              //     height: "8px"
                              // },
                              color: "black",
                            }}
                            value={
                              editedRow.validFrom
                                ? dayjs(editedRow.validFrom)
                                : null
                            }
                            onChange={(date, context) =>
                              handleValidFromNew(date, context)
                            }
                            // onKeyDown={(e) => handleNewEnterKey(e)}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                onBlur: createLut,
                                onKeyDown: handleNewEnterKey,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </TableCell>
                      <TableCell sx={{ width: "150px" }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Valid To"
                            format="DD/MM/YYYY"
                            size="small"
                            // disabled
                            value={
                              editedRow.validTo
                                ? dayjs(editedRow.validTo)
                                : null
                            }
                            minDate={dayjs(editedRow.validFrom)}
                            onChange={(date, context) =>
                              handleValidToNew(date, context)
                            }
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                onBlur: createLut,
                                onKeyDown: handleNewEnterKey,
                              },
                            }}
                            sx={{
                              "& .MuiFormLabel-root": {
                                top: `${
                                  editedRow.validTo === "" ? "-9px" : "0px"
                                }`,
                              },
                              ".MuiInputBase-input": {
                                padding: "8.5px 14px",
                              },
                              color: "black",
                            }}
                            // onBlur={createLut}
                          />
                        </LocalizationProvider>
                      </TableCell>
                      <TableCell sx={{ width: "150px" }}>
                        {!editedRow.expiry ? (
                          ""
                        ) : editedRow.expiry <= 0 ? (
                          <span style={{ color: "red" }}>Expired</span>
                        ) : (
                          editedRow.expiry
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Box
                          sx={{
                            display: "flex",
                            // justifyContent: "center",
                          }}
                        >
                          {editedRow.editable && (
                            <>
                              <IconButton
                                disableRipple
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#fbc7c78c",
                                }}
                                onClick={createLut}
                              >
                                <DoneIcon
                                  sx={{
                                    fontSize: `15px`,
                                    color: "#6096d9",
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                disableRipple
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#fbc7c78c",
                                }}
                                ref={buttonRefclose}
                                onClick={() => {
                                  setEditedRow({
                                    option: "",
                                    editable: false,
                                    new: true,
                                    id: listLUT.length,
                                  });
                                }}
                              >
                                <CloseIcon
                                  sx={{
                                    fontSize: "18px",
                                    color: "#eb6a6a",
                                  }}
                                />
                              </IconButton>
                            </>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                  {listLUT && listLUT?.length > 0 ? (
                    listLUT.map((column, index) => {
                      const currentDate = moment().format("YYYY-MM-DD");
                      const validFrom = new Date(
                        column?.ValidFrom * 1000
                      ).toLocaleDateString();
                      const validTo = new Date(
                        column?.ValidTo * 1000
                      ).toLocaleDateString();

                      const finEndDate = moment(validTo).format("YYYY-MM-DD");
                      const diffInDays = moment(finEndDate).diff(
                        moment(currentDate),
                        "days"
                      );
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor: "#fff",
                          }}
                        >
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {column?.editable === true ? (
                              <TextField
                                size="small"
                                required={true}
                                type="text"
                                error={column?.LUTNo ? false : true}
                                value={column?.LUTNo}
                                inputRef={textFieldRefs}
                                onChange={(e) => handleEditChange(e, column)}
                                onKeyDown={(e) =>
                                  handleEditEnterClick(e, column)
                                }
                                // onBlur={(e) => handleEditBtnClick(e, column)}
                              />
                            ) : (
                              column?.LUTNo
                            )}
                          </TableCell>

                          <TableCell>
                            {column?.editable === true ? (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Valid From"
                                  format="DD/MM/YYYY"
                                  size="small"
                                  value={dayjs(validFrom)}
                                  sx={{
                                    "& .MuiFormLabel-root": {
                                      top: `${
                                        validFrom === "" ? "-9px" : "0px"
                                      }`,
                                    },
                                    ".MuiInputBase-input": {
                                      padding: "8.5px 14px",
                                    },
                                    color: "black",
                                  }}
                                  slotProps={{
                                    textField: {
                                      variant: "outlined",
                                      // onBlur: (e) => {
                                      //   handleEditBtnClick(e, column);
                                      // },
                                      onClick: () => setDateFrom(true),
                                      inputRef: { validFromref },
                                    },
                                  }}
                                  onChange={(date, context) =>
                                    handleEditChangeValid(date, context, column)
                                  }
                                />
                              </LocalizationProvider>
                            ) : (
                              validFrom
                            )}
                          </TableCell>
                          <TableCell>
                            {column?.editable === true ? (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Valid To"
                                  format="DD/MM/YYYY"
                                  size="small"
                                  value={dayjs(validTo)}
                                  sx={{
                                    "& .MuiFormLabel-root": {
                                      top: `${validTo === "" ? "-9px" : "0px"}`,
                                    },
                                    ".MuiInputBase-input": {
                                      padding: "8.5px 14px",
                                    },
                                    color: "black",
                                  }}
                                  onChange={(date, context) =>
                                    handleEditChangeValidTo(
                                      date,
                                      context,
                                      column
                                    )
                                  }
                                  // onChange={() => handleEditChange(date, context)}
                                  // onKeyDown={(e) =>
                                  //   handleEditEnterClick(e, column)
                                  // }
                                  slotProps={{
                                    textField: {
                                      variant: "outlined",
                                      // onBlur: (e) =>
                                      //   handleEditBtnClick(e, column),
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            ) : (
                              validTo
                            )}
                          </TableCell>
                          <TableCell align="center" color="red">
                            {!diffInDays ? (
                              ""
                            ) : diffInDays < 0 ? (
                              <span style={{ color: "red" }}>Expired</span>
                            ) : (
                              diffInDays
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Box
                              sx={{
                                display: "flex",
                                // justifyContent: "center",
                              }}
                            >
                              <IconButton
                                disableRipple
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#b1d1f97d",
                                }}
                                ref={editBtnref}
                                onClick={(e) => {
                                  // if (index === 0) {
                                  handleEditBtnClick(e, column);
                                  // } else {
                                  //   showErrorSnackbar(
                                  //     "Can't edit multiple types"
                                  //   );
                                  // }
                                }}
                              >
                                {column?.editable === true ? (
                                  <DoneIcon
                                    sx={{
                                      fontSize: `15px`,
                                      color: "#6096d9",
                                    }}
                                  />
                                ) : (
                                  <EditIcon
                                    sx={{
                                      fontSize: `15px`,
                                      color: "#6096d9",
                                    }}
                                  />
                                )}
                              </IconButton>
                              <IconButton
                                disableRipple
                                // disabled={
                                //   Object.keys(listLUT).length == 1 ? true : false
                                // }
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#fbc7c78c",
                                }}
                                onClick={() => handleDelete(column)}
                              >
                                <DeleteIcon
                                  sx={{
                                    fontSize: "15px",
                                    color: "#eb6a6a",
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        style={{ height: "300px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Snackbar
              open={snakopen}
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              autoHideDuration={5000}
              onClose={handleSnakClose}
            >
              <Alert
                onClose={handleSnakClose}
                variant="filled"
                severity={"warning"}
                // sx={{
                //   width: "100%",
                //   color: theme?.palette?.TmId.id.toString().includes("9")
                //     ? "white"
                //     : "",
                // }}
              >
                Please provide LUT number
              </Alert>
            </Snackbar>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ dispaly: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  disableElevation
                  disabled={editData.editable === true}
                  size="small"
                  onClick={(e) => {
                    addNewRow(e);
                    // if (!lutDetails?.[lutDetails?.length - 1]?.editable) {
                    //   setNewRowStatus(true);
                    //   addNewLutDetails();
                    //   scrollToBottom();
                    // } else {
                    //   showWarningSnackbar("Please Fill the Existing Row");
                    // }
                  }}
                  startIcon={<AddBox />}
                  sx={{
                    fontSize: "12px",
                    marginTop: "15px",
                  }}
                  //   disabled={lutValidStatus == true ? false : true}
                >
                  Add New Line
                </Button>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={backdropOpen}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              </Box>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default LutViewNewModal;
